import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

import { is1593 } from 'utils/func';
import RichTextViewer from 'components/RichTextViewer';
import HardProductFields from './HardProductFields';
import KPITable from './KPITable';
import SoftProductFields from './SoftProductFields';
import ResearchContributions from './ResearchContributions';

export default function ResearchResult({ data, researchType, general }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div>
      <h4>{t('projectProposal.researchResult.viewLabel')}</h4>
      <h4>{t('projectProposal.researchResult.productAndResearchResultDes.label')}</h4>
      <SoftProductFields products={data?.softProducts} />
      <HardProductFields
        products={data?.hardProducts}
        qualityComparison={data?.qualityComparison}
      />
      <h4>{t('projectProposal.researchResult.kpis.label')}</h4>
      <KPITable kpis={data?.projectProposalResearchKpis} />
      {is1593(general?.template) && (
        <div className="mt-4">
          <h4 className="text-lg text-red-500">
            {t('projectProposal.researchResult.kpis.k9_details')}
          </h4>
          <RichTextViewer
            value={general?.k9Details ?? ''}
            showHeader={false}
            style={{ height: '300px' }}
            readOnly
          />
        </div>
      )}
      <ResearchContributions data={data} researchType={researchType} />
    </div>
  );
}

ResearchResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  researchType: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  general: PropTypes.object.isRequired,
};
